const KEY = 'signupInProgress';

export function markSignupInProgress(uid, authRoute) {
	try {
		sessionStorage.setItem(KEY, JSON.stringify({ uid, authRoute }));
	} catch (error) {
		console.error('Could not mark signup in progress:', error);
	}
}

export function readSignupInProgress() {
	try {
		return JSON.parse(sessionStorage.getItem(KEY)) || null;
	} catch (error) {
		return null;
	}
}

export function clearSignupInProgress() {
	try {
		sessionStorage.removeItem(KEY);
	} catch (error) {
		console.error('Could not clear signup marker:', error);
	}
}
